import React from 'react';
import { Box, Typography } from '@mui/material';

interface KpiMetricProps {
  value: number | string;
  label: string;
  color?: string;
}

const KpiMetric: React.FC<KpiMetricProps> = ({ value, label, color = '#AB854A' }) => {
  return (
    <Box className='flex-1 min-w-0 text-center'>
      <Typography
        className='!text-center !tracking-[0%]'
        sx={{
          color: color,
          fontFamily: 'CircularStd',
          // Scales with available width and can break, so a large count never
          // forces its grid track past the container (which caused a
          // horizontal page scroll). minWidth:0 on the Box lets the track shrink.
          fontSize: { xs: '40px', md: 'clamp(44px, 5vw, 94px)' },
          fontStyle: 'normal',
          fontWeight: 450,
          lineHeight: { xs: '44px', md: 1.05 },
          overflowWrap: 'anywhere',
        }}
      >
        {value}
      </Typography>
      <Typography
        className='!font-normal !text-text-1 !tracking-[0%]'
        sx={{
          fontFamily: 'CircularStd',
          lineHeight: 'normal',
          textAlign: 'center',
          marginTop: { xs: '8px', md: '17px' },
          fontSize: { xs: '12px', md: '17px' },
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default KpiMetric;
